import { useState } from 'react'

import { iziplaySubtitle } from '../tools/api'
import { Button, Dialog, Select, TextField } from '@iziplay/ui-kit'

interface SubtitleModalProps {
  onClose?: () => void
  fileId: string
  open: boolean
  onUpload?: ({ id, lang }: { id: string; lang: string }) => void
}

function SubtitleModal(props: SubtitleModalProps) {
  const { onClose, onUpload, fileId, open } = props
  const [name, setName] = useState('No name')
  const [lang, setLang] = useState('eng')

  const callOnClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const selectFile = (evt: any) => {
    console.log(props)
    console.log(evt)
    const reader = new FileReader()
    reader.onload = async event => {
      const srt =
        typeof event?.target?.result === 'string'
          ? event?.target?.result.replace('data:application/octet-stream;base64,', '')
          : ''
      const res = await iziplaySubtitle().post(`/file/${fileId}/srt`, {
        name,
        lang,
        srt
      })

      if (onClose) {
        onClose()
      }
      if (onUpload) {
        onUpload({
          id: res.data.internalID,
          lang
        })
      }
    }
    reader.readAsDataURL(evt.target.files[0])
  }

  return (
    <Dialog
      open={open}
      onClose={callOnClose}
      title="Import a subtitle"
      actions={
        <label htmlFor="btn-upload">
          <input
            id="btn-upload"
            name="btn-upload"
            style={{ display: 'none' }}
            type="file"
            accept=".srt"
            onChange={selectFile}
          />
          <Button className="btn-choose" onClick={() => document.getElementById('btn-upload')?.click()}>
            Select file
          </Button>
        </label>
      }
    >
      <p>
        Import a SRT file from your computer that will be visible in the player and Chromecast if
        available
      </p>

      <TextField
        id="subtitle-name"
        label="Name"
        value={name}
        onChange={evt => setName(evt.target.value || '')}
      />

      <Select
        id="subtitle-lang"
        label="Language"
        value={lang}
        onChange={setLang}
        options={[
          { value: 'eng', label: 'English' },
          { value: 'fra', label: 'French' },
          { value: '', label: 'N/A' }
        ]}
      />
    </Dialog>
  )
}

export { SubtitleModal }
